import React from 'react';
import { Edit2 } from 'react-feather';
import { isEmpty } from 'lodash';
import LESSON_STATES from 'constants/lesson_states';
import { routes } from 'constants/config';
import { Button, Spinner } from 'ui';
import { useFetch, useFeatureFlags, useToggle } from 'components/shared/hooks';
import ScormModal from 'components/content/scorm/ScormModal';
import FeatureFlag from 'components/shared/FeatureFlag';

const ScormButton = ({ lesson, workspaces }) => {
  const scormId = lesson.scorms[0].id;
  const [scormModalVisible, toggleScormModal] = useToggle();
  const { data: scormData = {} } = useFetch(routes.SCORM_DATA(scormId));
  const hasWorkspaceFeature = useFeatureFlags('workspaces');

  return (
    <>
      <Button
        className="ws-nw mr-32"
        disabled={isEmpty(scormData)}
        onClick={toggleScormModal}
      >
        <span className="d-f ai-c">
          {isEmpty(scormData) && <Spinner className="Icon" />}
          {!isEmpty(scormData) && (
            <>
              <Edit2 className="mr-8 c-midnight-50" size={16} />
              <EditButtonText state={lesson.state} />
            </>
          )}
        </span>
      </Button>
      {scormModalVisible && (
        <ScormModal
          closeScormModal={toggleScormModal}
          scormModalVisible={scormModalVisible}
          workspaces={workspaces}
          hasWorkspaceFeature={hasWorkspaceFeature}
          title={scormData.title}
          description={scormData.description}
          popout={scormData.popout}
          finish={scormData.finish}
          restart={scormData.restart}
          fullWidth={scormData.display_full_width}
          workspaceId={scormData.workspace_id}
          scormId={scormId}
          lessonId={lesson.id}
        />
      )}
    </>
  );
};

const EditButtonText = ({ state }) => {
  switch (state) {
    case LESSON_STATES.PUBLISHED:
      return t('lesson_overview.actions.new_draft');
    case LESSON_STATES.CLASSIC:
      return t('lesson_overview.actions.update');
    case LESSON_STATES.DRAFT:
    case LESSON_STATES.NEW_VERSION_PENDING:
    default:
      return t('lesson_overview.actions.edit');
  }
};

const LessonEditButton = ({ lesson, workspaces }) => {
  const isArchived = lesson.archivedAt !== null;

  if (lesson.scorm && !isArchived) {
    return (
      <FeatureFlag features={['scorm_versions_editing']}>
        <ScormButton lesson={lesson} workspaces={workspaces} />
      </FeatureFlag>
    );
  }

  return (
    !lesson.scorm &&
    !isArchived && (
      <Button
        className="d-f jc-c ws-nw mr-32"
        url={routes.LESSON_OVERVIEW.EDIT_LESSON(lesson.id)}
      >
        <span className="d-f ai-c">
          <Edit2 className="mr-8 c-midnight-50" size={16} />
          <span className="pl-8 pr-8">
            <EditButtonText state={lesson.state} />
          </span>
        </span>
      </Button>
    )
  );
};
export default props => <LessonEditButton {...props} />;
